module.exports = __webpack_public_path__ + "img/stock7.8c592420.png";